import React, { FC, memo } from 'react';
import BreadcrumbItem from './item';
import styled from 'styled-components';
import colors from '../../config/colors';
interface IBreadcrumbs {
  items: Array<Object>
}

const Breadcrumbs : FC <IBreadcrumbs>= ({items, ...props}) => {
  return (
    <BreadcrumbsUl > {
      items.map((item: any, i: number) => {
        return (<BreadcrumbItem key={i} item={item} />)
      })
    }
    </BreadcrumbsUl>
  )
}
export default memo(Breadcrumbs);

const BreadcrumbsUl = styled.ul`
  list-style: none;
  margin: 0;
  padding: 10px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  background: ${colors.WHITE};
  font-family: "Gilroy-Medium";

  li {
    font-size: 16px;
    padding-left: 8px;
    color: ${colors.GRAY_MEDIUM};

    &:last-child {
      color: ${colors.PRIMARY_PURPLE};
    }
    a {
      color: ${colors.GRAY_MEDIUM};

      &:hover {
        color: ${colors.PRIMARY_ORANGE};
      }
    }

    svg {
      width: 16px;
      height: 16px;
      stroke: #848484;
    }

    &:before {
      content: "/";
      color: ${colors.GRAY_MEDIUM};
      display: inline-block;
      margin-right: 8px;
    }

    &:first-child {
      padding-left: 0;

      &:before {
        display: none;
      }
    }
  }
`;
